import { render, staticRenderFns } from "./editInvoice.vue?vue&type=template&id=4dfeadde&scoped=true"
import script from "./editInvoice.vue?vue&type=script&lang=js"
export * from "./editInvoice.vue?vue&type=script&lang=js"
import style0 from "./editInvoice.vue?vue&type=style&index=0&id=4dfeadde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfeadde",
  null
  
)

export default component.exports